var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: { id: "new_user" },
      on: {
        click: function($event) {
          _vm.closeMenu()
        }
      }
    },
    [
      _c("dd-header", { ref: "menuRef", attrs: { headerType: 2 } }),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("dd-sitemap", {
                  attrs: {
                    pageKey: _vm.pageKey,
                    pageList: _vm.pageList,
                    mapStyle: "topic_path"
                  }
                }),
                _vm._v(" "),
                _c("dd-corp-input", {
                  ref: "corpInput",
                  attrs: {
                    isEdit: true,
                    corpForm: _vm.corpForm,
                    isPrivateUser: _vm.isPrivateUser,
                    isManager: true
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "control_btn_area" }, [
                  _c(
                    "button",
                    {
                      staticClass: "main_btn sel_sub_btn",
                      on: {
                        click: function($event) {
                          _vm.update()
                        }
                      }
                    },
                    [_vm._v("更新する")]
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71cd89ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71cd89ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcUpdateCorpInput.vue
// module id = null
// module chunks = 